import { createAction } from 'redux-actions';

export const fetchAllApiResources = createAction('FETCH_ALL_API_RESOURCES');
export const fetchAllApiResourcesSuccess = createAction('FETCH_ALL_API_RESOURCES_SUCCESS');
export const fetchAllApiResourcesFailure = createAction('FETCH_ALL_API_RESOURCES_FAILURE');
